import { useMemo } from 'react';
import { ComponentStyle } from "@/theme/styles.types.ts";


const useComputedStyles = (
	styles: ComponentStyle[],
	conditions: Record<string, boolean> = {},
	features: string[] = [],
	customClasses = ''
): string => {
	return useMemo(() => {
		const combinedStyles = styles.reduce((acc, styleDef) => {
			const base = styleDef.default || '';
			const state = styleDef.states
				? Object.keys(conditions)
					.filter(key => conditions[key] && styleDef.states?.[key])
					.map(key => styleDef.states?.[key])
					.join(' ')
				: '';
			const varStyle = styleDef.variants
				? features.filter(feat => styleDef.variants?.[feat]).map(feat => styleDef.variants?.[feat]).join(' ')
				: '';
			const sizeStyle = styleDef.sizes
				? features.filter(feat => styleDef.sizes?.[feat]).map(feat => styleDef.sizes?.[feat]).join(' ')
				: '';

			return `${acc} ${base} ${state} ${varStyle} ${sizeStyle}`.replace(/\s+/g, ' ');
		}, '');

		return `${combinedStyles} ${customClasses}`.trim();
	}, [styles, conditions, features, customClasses]);
};

export default useComputedStyles;
